import { render, staticRenderFns } from "./StatsBestPerformersModal.vue?vue&type=template&id=553afd20&"
import script from "./StatsBestPerformersModal.vue?vue&type=script&lang=js&"
export * from "./StatsBestPerformersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports